import { lazy, Suspense } from "react";

import { useWhatsNewFenster } from "@/hooks/useWhatsNew";

// ---------------------------------------------------------------------------
// WhatsNewGate — oeffnet das Fenster «Was ist neu», wenn der Server eines hat
// (NEU-1). Lebt in der App-Shell, damit es beim naechsten Oeffnen der App auf
// JEDER Seite erscheint — auch bei laufender Sitzung, auch in der
// installierten App.
// ---------------------------------------------------------------------------
// Der Dialog selbst ist ein Lazy-Chunk: das Initial-Bundle traegt nur die
// Abfrage (size-limit-Budget). In Vertretung fragt der Hook gar nicht.

const WhatsNewDialog = lazy(() => import("@/components/shell/WhatsNewDialog"));

export function WhatsNewGate() {
  const fenster = useWhatsNewFenster();
  if (!fenster.data || fenster.data.mode !== "fenster") return null;
  return (
    <Suspense fallback={null}>
      <WhatsNewDialog fenster={fenster.data} />
    </Suspense>
  );
}
